import { CommerceService } from "@/services/commerce"

/**
 * Retrieves the assigned customers for a given ADM number and tour schedules.
 *
 * @param {string} admNumber - The ADM number.
 * @param {Array} tourSchedules - The tour schedules.
 * @param {number} limit - The maximum number of customers to retrieve.
 * @param {number} offset - The number of customers to skip before starting to retrieve.
 * @param {Object} sort - The sorting options for the retrieved customers.
 * @returns {Promise<Array>|null} - A promise that resolves to an array of assigned customers or null if no customers are found.
 */
export const getAdmAssignedCustomers = async ({ admNumber, tourSchedules, limit, offset, sort }) => {
  const commerceApi = CommerceService.api()
  let tourNumberQuery = ""

  if (tourSchedules && tourSchedules.length > 0) {
    let tourNumbersStrings = tourSchedules.map((tour) => {
      if (!tour) return null

      let tours = [
        tour.tour01,
        tour.tour02,
        tour.tour03,
        tour.tour04,
        tour.tour05,
        tour.tour06,
        tour.tour07,
        tour.tour08,
      ]

      tours = tours.filter((n) => n)

      const tourNumberStrings = tours.map((tourItem) => `"${tourItem}"`)

      return tourNumberStrings.join(",")
    })

    tourNumbersStrings = tourNumbersStrings.filter((n) => n)

    const tourNumberString = tourNumbersStrings.join(",")

    tourNumberQuery = `and tourNumber in (${tourNumberString})`
  }
  const admAssignedCustomers = (
    await commerceApi
      .customers()
      .get({
        queryArgs: {
          where: `custom(fields(admSalesRepresentive="${admNumber}" ${tourNumberQuery}))`,
          sort: sort ? `${sort.orderBy} ${sort.direction}` : null,
          limit: limit,
          offset: offset,
        },
      })
      .execute()
  )?.body

  return admAssignedCustomers ?? null
}
